<div class="login_main_wrp">
    <div class="login_main_wrpbody">
        <div class="login_cont">
            <div class="login_body">
                <img src="https://all-frontend-assets.s3.amazonaws.com/broko-design/broko_v1_logo.png" class="logoImg">
                <h1>Broko CRM <span>Login</span></h1>

                <mat-card class="login_form_cont">
                    <form>
                        <div class="login_field_wrp">
                            <mat-form-field class="example-full-width">
                                <img class="login_field_icon"
                                    src="https://all-frontend-assets.s3.amazonaws.com/broko-design/login_mail_icon.webp">
                                <!-- <mat-label>Email</mat-label> -->
                                <input matInput placeholder="Email" value="">
                            </mat-form-field>


                            <mat-form-field class="example-full-width">
                                <img class="login_field_icon"
                                    src="https://all-frontend-assets.s3.amazonaws.com/broko-design/login_lock_icon.webp">
                                <!-- <mat-label>Password</mat-label> -->
                                <input matInput placeholder="Password" value="" type="password">
                            </mat-form-field>

                            <div class="login_flx">
                                <p>Trouble Logging In? <br /><span>Reset Password</span></p>
                                <p>Not a member yet? <br /><span>Register Now</span></p>
                            </div>
                            <button mat-button>Login</button>
                        </div>
                    </form>
                </mat-card>
            </div>
        </div>
    </div>

</div>